import { UIAsset } from '../config/assets';
import { UIIcon } from '../config/icons';
import { ABPaymentForm } from '../lib/ab/payment';
import { aTrackPage } from '../lib/mdl/a-track';
import { c_cities } from '../lib/mdl/c-city';
import { CPlan, cPlanDiscountedPrice, cPlanPromoEffectPrice } from '../lib/mdl/c-plan';
import { CLoginUser, CPaidPlanId } from '../lib/mdl/c-user';
import { EPaymentIntent } from '../lib/mdl/e-payment-intent';
import { the_links } from '../lib/mdl/f-links';
import { PPromo } from '../lib/mdl/p-promo';
import { meAction, meGetInfo, MEInfoSubscribe, MEReferralUser, meUseCode, MeUseCodeResponse } from '../lib/me/home';
import { meEmailLogin, meEmailTokenLogin, meForgotPassword, MELoginEnvironment, mePhoneTokenLogin, mePreSignup, meResetPassword, meSignup, the_user } from '../lib/me/login';
import { getCountry, meUpdate, meUpdatePhone } from '../lib/me/me';
import { otpSend, otpStartEmail, otpStartPhone, otpVerify } from '../lib/me/otp';
import { uiSetBG } from '../lib/ui/bg';
import { UIButton } from '../lib/ui/component/button';
import { UICodeInput } from '../lib/ui/component/code';
import { UIDialog } from '../lib/ui/component/dialog';
import { UITextInput } from '../lib/ui/component/input';
import { UIAutofill } from '../lib/ui/component/input-base';
import { uiToast } from '../lib/ui/component/toast';
import { $el } from '../lib/ui/elements';
import { uiLock, uiReplaceI18N } from '../lib/ui/functions';
import { $recaptcha } from '../lib/ui/media/recaptcha';
import { UIScreen } from '../lib/ui/screen';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $analytics } from '../lib/y/analytics';
import { $auth } from '../lib/y/auth';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $form } from '../lib/y/form';
import { $format } from '../lib/y/format';
import { $i18n, yGetI18N, yInterpolate } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { YCountryId, YId } from '../lib/y/types';
import { yRandomInt } from '../lib/y/util';

class PromoDialog extends UIDialog<MeUseCodeResponse> {
    constructor() {
        super({ close: true, classes: 'm-550' })

        const code = new UITextInput({ required: true, placeholder: $i18n.tl.ph_voucher_code, autofocus: true });

        this.content.ui_add([
            $el.DIV('w-block l-form m-center', [
                $el.H2('title', $i18n.tl.t_promo_code),
                code,
                $el.DIV('l-button-row', [
                    new UIButton({
                        title: $i18n.tl.b_apply_code, classes: 'ui-tint-reverse', on_click: () => {
                            if(!$form.validate(code)) return;

                            meUseCode('subscribe', code.value).then(response => {
                                this.dismiss(response);
                            }, uiToast);
                        }
                    })
                ])
            ])
        ]);
    }
}

class LoginSection extends UIView {
    constructor(on_challenge: (phone: string, challenge: string) => void, on_email: (email: string, password: string) => void, on_forgot: () => void, on_signup: () => void) {
        const phone = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_phone, autofill: UIAutofill.PHONE, required: true, autofocus: true });
        const phone_login = new UIButton({
            title: $i18n.tl.b_login_phone, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate(phone)) return;

                return $recaptcha.execute('otp').then(token => {
                    return otpStartPhone(phone.value, token).then(r => {
                        $log('app', 'otp response', r);
                        $analytics.track('OTP request', { phone: r.phone, recaptcha_ok: r.recaptcha_ok, recaptcha_score: r.recaptcha_score, flow: 'login' });
                        return on_challenge(r.phone, r.challenge);
                    }, uiToast);
                });
            }
        });
        const email = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true, autofocus: true });
        const password = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'password', placeholder: $i18n.tl.ph_password, autofill: UIAutofill.PASSWORD, required: true });
        const email_login = new UIButton({
            title: $i18n.tl.b_login_email, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([email, password])) return;

                return on_email(email.value, password.value);
            }
        });
        const forgot = new UIButton({
            kind: 'k-text', title: $i18n.tl.b_forgot, classes: 'tl-signup-text-button', on_click: () => {
                on_forgot();
            }
        });
        const signup = new UIButton({
            kind: 'k-text', title: $i18n.tl.b_not_member, classes: 'tl-signup-text-button', on_click: () => {
                on_signup();
            }
        })
        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.b_login),
            phone,
            phone_login,
            $el.DIV('tl-signup-or', [
                $el.DIV('r-separator'),
                $el.DIV('r-text', $i18n.tl.t_signup_or),
                $el.DIV('r-separator')
            ]),
            email,
            password,
            email_login,
            forgot,
            signup,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class ForgotSection extends UIView {
    constructor(on_sent: (email: string) => void) {
        const email = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true, autofocus: true });
        const send = new UIButton({
            title: $i18n.tl.b_send, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([email])) return;
                $analytics.track('Password request');
                const email_value = email.value;
                meForgotPassword('home', email_value).then(() => {
                    on_sent(email_value);
                }, uiToast);
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.h_forgot),
            email,
            send,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class PasswordResetSection extends UIView {
    constructor(_on_reset: (email: string) => void) {
        const password = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'password', placeholder: $i18n.tl.ph_password, autofill: UIAutofill.PASSWORD, required: true });
        const reset = new UIButton({
            title: $i18n.tl.b_send, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([password])) return;
                meResetPassword('home', password.value).then(() => {
                    $analytics.track('Password reset');
                    $location.navigate([]);
                }, uiToast);
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.h_reset_pw),
            $el.P('text', $i18n.tl.t_reset_pw),
            password,
            reset,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class ForgotSentSection extends UIView {
    constructor(email: string, on_done: () => void) {
        const done = new UIButton({
            title: $i18n.tl.b_ok, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                on_done();
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.P('text', $i18n.tl.t_forgot_sent + ' ' + email),
            done,
            $el.P('text', $i18n.tl.t_forgot_spam),
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class PhoneSection extends UIView {
    constructor(on_challenge: (phone: string, challenge: string) => void, on_login: () => void) {
        const phone = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_phone, autofill: UIAutofill.PHONE, required: true, autofocus: true });
        const next = new UIButton({
            title: $i18n.tl.b_signup_phone, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate(phone)) return;

                return $recaptcha.execute('otp').then(token => {
                    return otpStartPhone(phone.value, token).then(r => {
                        $log('app', 'otp response', r);
                        $analytics.track('OTP request', { phone: r.phone, recaptcha_ok: r.recaptcha_ok, recaptcha_score: r.recaptcha_score, flow: 'signup' });
                        return on_challenge(r.phone, r.challenge);
                    }, uiToast);
                });
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_enter_phone),
            phone,
            next,
            $el.P('small', [$i18n.tl.t_signup_already, ' ', new UIButton({ kind: 'k-text', classes: 'm-inline tl-signup-inline-button m-dark', title: $i18n.tl.b_login, on_click: () => { on_login() } })]),
            $el.P('small', [uiReplaceI18N($i18n.tl.t_signup_accept, $el.A(the_links.terms, $i18n.tl.t_signup_terms, 't-underline'), $el.A(the_links.privacy, $i18n.tl.t_signup_privacy, 't-underline')), ' ', $recaptcha.makeWarning()]),
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class VerifySection extends UIView {
    constructor(on_challenge: (phone: string, challenge: string) => void) {
        const phone = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_phone, autofill: UIAutofill.PHONE, required: true, autofocus: true });
        const next = new UIButton({
            title: $i18n.tl.t_signup_verify_phone, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate(phone)) return;

                return $recaptcha.execute('otp').then(token => {
                    return otpStartPhone(phone.value, token).then(r => {
                        $log('app', 'otp response', r);
                        $analytics.track('OTP request', { phone: r.phone, recaptcha_ok: r.recaptcha_ok, recaptcha_score: r.recaptcha_score, flow: 'verify' });
                        return on_challenge(r.phone, r.challenge);
                    }, uiToast);
                });
            }
        });

        super('section', 'ui-section w-block l-form', [
            $el.H2('signup-title', $i18n.tl.t_signup_verify_phone),
            phone,
            next
        ]);
    }
}

class PhoneCodeSection extends UIView {
    constructor(challenge: string, ac: AbortController | undefined, on_token: (token: string) => void) {
        const code = new UICodeInput({ required: true, autofocus: true, classes: 'm-stretch' });
        code.on_code = code => {
            return otpVerify(challenge, code).then(r => {
                $log('app', 'otp response', r);
                on_token(r.token);
                return true;
            }, message => {
                uiToast(message);
                return false
            });
        };

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_enter_phone_code),
            code,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);

        $auth.getOTP(ac).then(otp => {
            code.value = otp;
        }, err => {
            $log('app', 'otp error', err);
        });

        otpSend(challenge).catch(uiToast);
    }
}

class VerifyCodeSection extends UIView {
    constructor(challenge: string, ac: AbortController | undefined, on_token: (token: string) => void) {
        const code = new UICodeInput({ required: true, autofocus: true, classes: 'm-stretch' });
        code.on_code = code => {
            return otpVerify(challenge, code).then(r => {
                $log('app', 'otp response', r);
                on_token(r.token);
                return true;
            }, message => {
                console.log('toasting', message);
                uiToast(message);
                return false;
            });
        };

        super('section', 'ui-section w-block l-form', [
            $el.H2('signup-title', $i18n.tl.t_signup_enter_phone_code),
            code
        ]);

        $auth.getOTP(ac).then(otp => {
            code.value = otp;
        }, err => {
            $log('app', 'otp error', err);
        });

        otpSend(challenge).catch(uiToast);
    }
}

class EmailCodeSection extends UIView {
    constructor(challenge: string, ac: AbortController | undefined, on_token: (token: string) => void) {
        const code = new UICodeInput({ required: true, autofocus: true, classes: 'm-stretch' });
        code.on_code = code => {
            return otpVerify(challenge, code).then(r => {
                $log('app', 'otp response', r);
                on_token(r.token);
                return true;
            }, message => {
                uiToast(message);
                return false;
            });
        };

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_enter_email_code),
            code,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);

        $auth.getOTP(ac).then(otp => {
            code.value = otp;
        }, err => {
            $log('app', 'otp error', err);
        });

        otpSend(challenge).catch(uiToast);
    }
}

class EmailSection extends UIView {
    constructor(on_email: (email: string) => void) {
        const email = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true, autofocus: true });
        const next = new UIButton({
            title: $i18n.tl.b_continue, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate(email)) return;

                return on_email(email.value);
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_ask_email),
            email,
            next,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class ExistingEmailSection extends UIView {
    constructor(pre_email: string, on_email: (email: string, password: string) => void, on_forgot: (challenge: string) => void) {
        const email = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true, autofocus: true });
        const password = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'password', placeholder: $i18n.tl.ph_password, autofill: UIAutofill.PASSWORD, required: true });
        const next = new UIButton({
            title: $i18n.tl.b_login_email, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([email, password])) return;

                return on_email(email.value, password.value);
            }
        });
        const forgot = new UIButton({
            kind: 'k-text', title: $i18n.tl.b_forgot, classes: 'tl-signup-text-button', on_click: () => {
                return otpStartEmail(email.value).then(r => {
                    $log('app', 'otp response', r);
                    on_forgot(r.challenge);
                }, uiToast);
            }
        });

        email.value = pre_email;

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_email_already),
            $el.P('text', $i18n.tl.t_signup_email_password),
            email,
            password,
            next,
            forgot,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class NameSection extends UIView {
    constructor(on_name: (first_name: string, last_name: string) => void) {
        const first_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_first_name, autofill: UIAutofill.FIRST_NAME, required: true });
        const last_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_last_name, autofill: UIAutofill.LAST_NAME, required: true });
        const next = new UIButton({
            title: $i18n.tl.b_continue, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([first_name, last_name])) return;

                on_name(first_name.value, last_name.value);
            }
        });

        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_ask_name),
            $el.P('text', $i18n.tl.t_signup_name_why),
            first_name,
            last_name,
            next,
            $el.S(),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

class CitySection extends UIView {
    constructor(on_city: (phone: YCountryId, city: YId) => void) {
        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_select_city),
            $el.P('text', $i18n.tl.t_signup_ask_city),
            $el.DIV('s-small'),
            $el.DIV('tl-signup-separator')
        ]);

        const cities = c_cities.all.filter(c => c.can_signup).sort((a, b) => a.id.localeCompare(b.id));

        for(const city of cities) {
            if(!city.can_signup) continue;
            const flag = $el.DIV('r-flag');
            uiSetBG(flag, { size: 'contain', media: city.country == 'DE' ? UIAsset.FLAG_DE : UIAsset.FLAG_SE });

            const city_button = $el.DIV('tl-signup-city-button', [
                flag,
                $el.DIV('r-text', city.name),
                $el.S(),
                $el.ICON(UIIcon.ANGLE_RIGHT, 'r-checkmark')
            ]);

            city_button.addEventListener('click', () => {
                $log('app', 'selected city', city);
                on_city(city.country, city.id);
            });

            this.ui_add([
                city_button,
                $el.DIV('tl-signup-separator')
            ]);
        }

        this.ui_add([
            $el.S(),
            $el.DIV('s-small'),
            $el.DIV('tl-signup-bottom-logo')
        ]);
    }
}

export function homeMakePlanCard(plan: CPlan, promo?: PPromo, _on_click?: () => void) {
    const plan_base_price = plan.price[getCountry()];

    let base_price = $format.currency(plan_base_price);
    let discounted_price = $format.currency(cPlanDiscountedPrice(plan, promo));

    const subscription_effect = promo?.effect.find(e => e.kind == 'subscription');

    if(subscription_effect) {
        base_price = $format.currency({ value: plan_base_price.value * subscription_effect.duration_months, currency: plan_base_price.currency });
        discounted_price = $format.currency(cPlanPromoEffectPrice(plan, subscription_effect));
    }

    const subscription_discount_effect = promo?.effect.find(e => e.kind == 'subscription_discount');

    return $el.DIV(['tl-signup-card'], [
        $el.DIV('r-title', yGetI18N(plan.name)),
        subscription_discount_effect ? [
            base_price != discounted_price && $el.DIV('r-text r-strike', base_price),
            $el.DIV('r-text', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price))
        ] : subscription_effect ? [
            base_price != discounted_price && $el.DIV('r-text r-strike', base_price),
            $el.DIV('r-text', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price, '' + subscription_effect.duration_months))
        ] : [
            $el.DIV('r-text', base_price)
        ],
        // $el.UL(yGetI18Ns(plan.points)),
        // new UIButton({ title:  $i18n.tl.b_choose_kind + ' ' + yGetI18N(plan.name), on_click: on_click, click_through: !on_click, classes: button_classes }),
        $el.DIV(['r-image', 'k-' + plan.id]),
        $el.ICON(UIIcon.ANGLE_RIGHT, 'r-caret')
    ]);
}

class SubscriptionSection extends UIView {
    constructor(info: MEInfoSubscribe, on_plan: (plan: CPaidPlanId, activate: boolean) => void, on_promo: (promo: PPromo) => void) {
        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_select_subscription),
            $el.P('text', $i18n.tl.t_signup_subscription_explain),

            info.plans.map(plan => {
                const card = homeMakePlanCard(plan, info.promo);
                card.addEventListener('click', () => {
                    on_plan(plan.id, !info.dont_activate);
                });
                return card;
            }),

            $el.DIV('s-section'),

            info.show_promo_field && [
                $el.DIV('l-button-row', new UIButton({
                    title: $i18n.tl.b_have_code, kind: 'k-text', on_click: () => {
                        new PromoDialog().present().then(response => {
                            if(response.kind == 'giftcard') {
                                $location.navigate([]);
                                return;
                            }
                            if(response.promo) {
                                on_promo(response.promo);
                            }
                        })
                    }
                })),
                $el.DIV('s-section')
            ]
        ]);
    }
}

class PaymentSection extends UIView {
    constructor(intent: EPaymentIntent, activate: boolean) {
        super('section', 'ui-section w-block l-form tl-signup-section', [
            $el.H2('signup-title', $i18n.tl.t_signup_select_subscription),
            new ABPaymentForm(intent, {
                finish: (model: CLoginUser) => {
                    Object.assign(the_user!, model);
                    $location.navigate([], { onboarding: true });
                }
            }),
            (!activate && intent.amount.value == 0) && $el.P('small', $i18n.tl.t_signup_dont_activate_text)
        ]);
    }
}

class ConfirmEmailSection extends UIView {
    constructor(on_done: () => void) {
        const email = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true, autofocus: true });
        email.value = the_user!.email!;
        const next = new UIButton({
            title: $i18n.tl.b_continue, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate(email)) return;
                return meUpdate({ email: email.value }).then(on_done);
            }
        });

        super('section', 'ui-section w-block l-form', [
            $el.H2('signup-title', $i18n.tl.t_signup_confirm_email),
            email,
            next
        ]);
    }
}

class ConfirmNameSection extends UIView {
    constructor(on_done: () => void) {
        const first_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_first_name, autofill: UIAutofill.FIRST_NAME, required: true });
        const last_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_last_name, autofill: UIAutofill.LAST_NAME, required: true });
        first_name.value = the_user!.first_name;
        last_name.value = the_user!.last_name;
        const next = new UIButton({
            title: $i18n.tl.b_continue, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([first_name, last_name])) return;
                return meUpdate({ first_name: first_name.value, last_name: last_name.value }).then(on_done);
            }
        });

        super('section', 'ui-section w-block l-form', [
            $el.H2('signup-title', $i18n.tl.t_signup_ask_name),
            $el.P('text', $i18n.tl.t_signup_name_why),
            first_name,
            last_name,
            next
        ]);
    }
}

class GenderAgeSection extends UIView {
    constructor(on_done: () => void) {
        const first_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_first_name, autofill: UIAutofill.FIRST_NAME, required: true });
        const last_name = new UITextInput({ kind: 'k-frame', classes: 'tl-signup-input', placeholder: $i18n.tl.ph_last_name, autofill: UIAutofill.LAST_NAME, required: true });
        const next = new UIButton({
            title: $i18n.tl.b_continue, classes: 'ui-tint-reverse tl-signup-button', on_click: () => {
                if(!$form.validate([first_name, last_name])) return;
                return meUpdate({ first_name: first_name.value, last_name: last_name.value }).then(on_done);
            }
        });

        super('section', 'ui-section w-block l-form', [
            $el.H2('signup-title', $i18n.tl.t_signup_ask_name),
            $el.P('text', $i18n.tl.t_signup_name_why),
            first_name,
            last_name,
            next
        ]);
    }
}

const signup_bgs = [
    UIAsset.SIGNUP_BG_1,
    UIAsset.SIGNUP_BG_2,
    UIAsset.SIGNUP_BG_3,
    UIAsset.SIGNUP_BG_4,
    UIAsset.SIGNUP_BG_5,
    UIAsset.SIGNUP_BG_6,
    UIAsset.SIGNUP_BG_7,
    UIAsset.SIGNUP_BG_8,
    UIAsset.SIGNUP_BG_9,
    UIAsset.SIGNUP_BG_10,
    UIAsset.SIGNUP_BG_11,
    UIAsset.SIGNUP_BG_12,
    UIAsset.SIGNUP_BG_13,
    UIAsset.SIGNUP_BG_14,
    UIAsset.SIGNUP_BG_15,
    UIAsset.SIGNUP_BG_16,
    UIAsset.SIGNUP_BG_17,
    UIAsset.SIGNUP_BG_19,
]

export class HomeSignupScreen extends UIScreen {
    private _ac: AbortController;
    private _current_section!: UIView;
    private _phone?: string;
    private _phone_token?: string;
    private _email?: string;
    private _first_name?: string;
    private _last_name?: string;

    constructor(private _start_login: boolean, private _gc_code?: string, private _origin?: string, private _start_subscribe?: boolean, private _password_reset?: boolean) {
        super();
        this._ac = new AbortController();
    }

    private _makeLoginEnvironment(): MELoginEnvironment {
        const codes = [...(window.ab_codes || [])];
        if(this._gc_code)
            codes.push(this._gc_code);

        return { codes };
    }

    private _replaceSection(new_section: UIView) {
        this._current_section.ui_replace(new_section);
        this._current_section = new_section;
    }

    toPhone() {
        this._replaceSection(new PhoneSection((phone, challenge) => {
            this._phone = phone;
            this.toPhoneCode(challenge);
        }, () => {
            this.toLogin();
        }));
    }

    toPhoneCode(challenge: string) {
        this._replaceSection(new PhoneCodeSection(challenge, this._ac, token => {
            this._phone_token = token;
            mePhoneTokenLogin(this._phone!, token, 'home', this._makeLoginEnvironment()).then(() => {
                if(the_user)
                    $location.navigate([]);
                else
                    this.toEmail();
            }, () => {
                this.toEmail();
            });
        }));
    }

    toEmail() {
        this._replaceSection(new EmailSection(email => {
            this._email = email;
            return mePreSignup('home', email, this._phone!, 'phone', this._phone_token!).then(r => {
                if(r.email_exists) {
                    this.toExistingEmail(email);
                    // } else if(r.verified_phone_exists) {
                    //     this.toExistingPhone(email);
                } else {
                    this.toName();
                }
            });
        }));
    }

    toExistingEmail(email: string) {
        this._replaceSection(new ExistingEmailSection(email, (email, password) => {
            const environment = this._makeLoginEnvironment();
            environment.verified_phone = this._phone;
            environment.phone_token = this._phone_token;

            meEmailLogin(email, password, 'home', environment).then(() => {
                $location.navigate([]);
            }, uiToast);
        }, challenge => {
            this.toEmailCode(challenge);
        }));
    }

    toEmailCode(challenge: string) {
        this._replaceSection(new EmailCodeSection(challenge, undefined, token => {
            const environment = this._makeLoginEnvironment();
            environment.verified_phone = this._phone;
            environment.phone_token = this._phone_token;

            meEmailTokenLogin(this._email!, token, 'home', environment).then(() => {
                $location.navigate([]);
            });
        }));
    }

    toName() {
        this._replaceSection(new NameSection((first_name, last_name) => {
            this._first_name = first_name;
            this._last_name = last_name;
            this.toCity();
        }));
    }

    toCity() {
        this._replaceSection(new CitySection((country, city) => {
            meSignup({ email: this._email!, first_name: this._first_name!, last_name: this._last_name!, phone: this._phone, country, city, identity_provider: 'phone', identity_token: this._phone_token }, 'home', this._makeLoginEnvironment()).then(() => {
                this.toSubscription();
            });
        }));
    }

    toSubscriptionWithInfo(info: MEInfoSubscribe) {
        this._replaceSection(new SubscriptionSection(info, (plan, activate) => {
            this.toPayment(plan, activate);
        }, promo => {
            info.promo = promo;
            info.show_promo_field = false;
            this.toSubscriptionWithInfo(info);
        }));
    }

    toSubscription() {
        meGetInfo('subscribe').then(info => {
            this.toSubscriptionWithInfo(info);
        })
    }

    toPayment(plan: CPaidPlanId, activate: boolean) {
        uiLock(meAction('subscribe', { plan: plan }).then(r => {
            if(r === true) {
                $location.navigate([], { onboarding: true });
            } else {
                console.log('in payment', activate);
                this._replaceSection(new PaymentSection(r, activate));
            }
        }));
    }

    toLogin() {
        this._replaceSection(new LoginSection((phone, challenge) => {
            this._phone = phone;
            this.toPhoneCode(challenge);
        }, (email, password) => {
            meEmailLogin(email, password, 'home', this._makeLoginEnvironment()).then(() => {
                $location.navigate([]);
            }, uiToast);
        }, () => {
            this.toForgot();
        }, () => {
            this.toPhone();
        }));
    }

    toForgot() {
        this._replaceSection(new ForgotSection((email: string) => {
            this.toForgotSent(email);
        }));
    }

    toPasswordReset() {
        this._replaceSection(new PasswordResetSection(() => {
        }));
    }

    toForgotSent(email: string) {
        this._replaceSection(new ForgotSentSection(email, () => {
            this.toLogin();
        }));
    }

    protected override fillContent(content: UIViewSpec): void {
        const origin = this._origin;

        content.classList.add('tl-signup-content');

        let bg = $el.DIV('tl-signup-bg', $el.DIV('r-icon'));
        let bg_index = yRandomInt(signup_bgs.length);
        uiSetBG(bg, { size: 'cover', media: signup_bgs[bg_index] });
        content.ui_add([
            bg,
            this._current_section = new UIView
        ]);

        if(this._start_subscribe)
            this.toSubscription();
        else if(this._start_login)
            this.toLogin();
        else if(this._password_reset)
            this.toPasswordReset();
        else
            this.toPhone();

        $analytics.track('Onboarding Started', { flow: origin });
        $analytics.track('Onboarding Your Info');
        aTrackPage('signup');
    }

    override onViewDidDisappear() {
        $log('app', 'aborting')
        this._ac.abort();
    }
}

export class HomeReferralPopup extends UIDialog {
    constructor(user: MEReferralUser) {
        super({ close: true, classes: 'm-440 c-light' });

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.DIV('asset-referral'),
            $el.H2('title', $i18n.tl.h_referral_popup + ' ' + user.first_name),
            $el.Ps('text', [user.first_name + ' ' + $i18n.tl.t_referral_popup_1, $i18n.tl.t_referral_popup_2, $i18n.tl.t_referral_popup_3]),
            $el.DIV('s-medium'),
            $el.DIV('l-button-row', [
                new UIButton({
                    title: $i18n.tl.b_read_more, classes: 'ui-tint-reverse m-hollow', on_click: () => {
                        this.dismiss(true);
                        $location.navigate(['how']);
                    }
                }),
                new UIButton({
                    title: $i18n.tl.b_try_month, classes: 'ui-tint-reverse', on_click: () => {
                        this.dismiss(true);
                        $location.navigate(['signup']);
                    }
                })
            ]),
        ]));
    }
}

export class HomeVerifyDialog extends UIDialog {
    private _current_section!: UIView;
    private _phone?: string;
    // private _phone_token?: string;
    private _ac: AbortController;

    private _replaceSection(new_section: UIView) {
        this._current_section.ui_replace(new_section);
        this._current_section = new_section;
    }

    toVerify() {
        this._replaceSection(new VerifySection((phone, challenge) => {
            this._phone = phone;
            this.toVerifyCode(challenge);
        }));
    }

    toVerifyCode(challenge: string) {
        this._replaceSection(new VerifyCodeSection(challenge, this._ac, token => {
            meUpdatePhone(this._phone!, token).then(() => {
                this.toConfirmEmail();
            }, message => {
                uiToast(message);
                this.toVerify();
            });
        }));
    }

    toConfirmEmail() {
        this._replaceSection(new ConfirmEmailSection(() => {
            this.toConfirmName();
        }));
    }

    toConfirmName() {
        this._replaceSection(new ConfirmNameSection(() => {
            if(xavis_experiments)
                this.toGenderAge();
            else
                this.dismiss(true);
        }));
    }

    toGenderAge() {
        this._replaceSection(new GenderAgeSection(() => {
            this.dismiss(true);
        }));
    }

    constructor() {
        super({ classes: 'm-550 m-mobile-fs' })

        this._ac = new AbortController();

        this.content.ui_add([
            $el.DIV('w-block l-form m-center', [
                this._current_section = new UIView
            ])
        ]);

        this.toVerify();
    }
}
